export default class Locale_Integrations { 
	FailedChangeStatusOnIntegrations: string = "Failed change status on integration";
	IntegrationSuccessfullyChanged: string = "Integration succesfully changed..";
	IntegrationConfigurationSuccessfullyChanged: string = "Integration Configuration successfully changed";
	GettingIntegrationsForTeamPlanner: string = "Getting integrations for TeamPlanner.";
}